module.exports = __webpack_public_path__ + "static/media/availability.d3f8a19c.svg";